<template>
  <div class="relative min-w-full px-4 py-12 mb-16 bg-clay-50">
    <div class="mx-auto max-w-7xl md:grid md:grid-cols-1 md:gap-x-16 md:gap-y-8 md:px-36">
      <div class="col-span-1">
        <!-- Changed overflow-hidden → overflow-visible so arrows can peek out -->
        <div class="relative w-full overflow-visible">
          <div class="max-w-6xl min-w-full mx-auto text-center">
            <h4 class="pr-4 text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
              Trending
              <a href="/musicals" class="underline hover:text-clay-800 hover:shadow-sm">Musicals</a>,
              <a href="/plays" class="underline hover:text-clay-800 hover:shadow-sm">Plays</a> &
              <a href="/operas" class="underline hover:text-clay-800 hover:shadow-sm">Operas</a>
            </h4>
            <p class="pt-2 mb-4 text-xl tracking-tight text-slate-800 sm:text-m lg:text-xl">
              See what shows performers are loving right now.
            </p>
          </div>

          <div v-if="popularGuides.length > 0" class="relative overflow-visible">
            <div class="flex justify-center w-full overflow-hidden">
              <div
                ref="track"
                class="flex w-full px-2 pb-5 mx-auto transition-transform duration-500 ease-in-out"
                :style="`transform: translateX(-${active * (100 / perView)}%)`"
              >
                <div
                  v-for="show in popularGuides"
                  
                  class="flex-shrink-0 w-1/4 px-4"
                >
                  <ShowCard class="pop-guide-shows" :show="show"  :key="show.id"/>
                </div>
              </div>
            </div>
            <!-- Prev -->
            <button
              @click="prev"
              class="absolute z-20 p-2 transform -translate-y-1/2 bg-white rounded-full shadow -left-6 top-1/2 hover:bg-gray-50"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="w-auto h-8 text-gray-300 hover:text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
              </svg>
            </button>

            <!-- Next -->
            <button
              @click="next"
              class="absolute z-20 p-2 transform -translate-y-1/2 bg-white rounded-full shadow -right-6 top-1/2 hover:bg-gray-50"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="w-auto h-8 text-gray-300 hover:text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>

          <SkeletonCard card-style="long" :num-of-cards="4" v-else />
        </div>
      </div>
    </div>
  </div>
</template>


<script setup lang="ts">
import { ref, computed, onMounted, nextTick } from "vue";
import { GetPopularGuidesRequest, GetPopularGuidesResponse, ShowDto } from "@/dtos";
import { client } from "@/shared";
import ShowCard from "../Guides/Shows/ShowCard.vue";
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";

const popularGuides = ref<ShowDto[]>([]);
const track         = ref<HTMLElement|null>(null);
const slideCount    = ref(0);
const active        = ref(0);

const perView    = 4;
const intervalMs = 10000;
const maxActive  = computed(() => Math.max(0, slideCount.value - perView));

function next() {
  const jump = perView;
  const cand = active.value + jump;
  active.value = cand <= maxActive.value ? cand : 0;
}

function prev() {
  const jump = perView;
  const cand = active.value - jump;
  active.value = cand >= 0 ? cand : maxActive.value;
}

async function updateSlideCount() {
  await nextTick();
  if (track.value) slideCount.value = track.value.children.length;
}

onMounted(async () => {
  const resp = await client.get<GetPopularGuidesResponse>(
    new GetPopularGuidesRequest()
  );
  popularGuides.value = resp.shows ?? [];
  await updateSlideCount();
});
</script>
